import React from 'react';
import { QuickstartPanel } from '@atlassian/jira-polaris-component-quickstart/src/components/QuickstartPanel.tsx';
import { fg } from '@atlassian/jira-feature-gating';

export const RightSidebars = () =>
	fg('temp_polaris_quickstart') ? <QuickstartPanel key="jpd-quickstart" /> : null;

RightSidebars.displayName = 'RightSidebars';
